import React from 'react';
import { Link } from 'react-router-dom';
import styles from './escala.module.css'; 
import img1 from './img/imagem1.jpg';

function FimEscala() {
  return (
    <div className={styles.paginaMateria}>
      <div className={styles.containerInterno}>
        
        <Link to="/blog" className={styles.btnVoltar}>
          &larr; Voltar para o Portal
        </Link>

        <header className={styles.cabecalhoMateria}>
          <span className={styles.tagMateria}>Informativo Trabalhista</span>
          <h1>Fim da Escala 6x1: Entenda o que Muda com a Emenda Constitucional nº 141/2026</h1>
          <p className={styles.subtitulo}>A jornada de trabalho no Brasil passou por uma transformação histórica. Entenda as novas regras, o cronograma de transição e o que a sua empresa deve fazer para se adequar, desde o RH até a operação no varejo e food service.</p>
          <span className={styles.dataPublicacao}>Publicado em 23 de Outubro de 2026</span>
        </header>

        <div className={styles.imagemDestaque}>
            <img src={img1} alt="Análise da declaração de imposto de renda" />
        </div>

        <article className={styles.conteudoTexto}>
          <p>
            A jornada de trabalho no Brasil passou por uma transformação histórica com a promulgação da <strong>Emenda Constitucional nº 141, em 16 de outubro de 2026</strong>. A medida altera o Artigo 7º da Constituição Federal, garantindo dois dias de repouso semanal remunerado e estabelecendo a redução progressiva da jornada máxima de trabalho para 40 horas semanais, sem redução salarial.
          </p>
          <p>
            Com o fim do modelo tradicional da escala 6x1, empresas, profissionais de Recursos Humanos (RH) e departamentos pessoais precisam reorganizar rotinas e rever escalas de trabalho para evitar passivos trabalhistas.
          </p>

          <h2>1. O que é a Emenda Constitucional nº 141/2026?</h2>
          <p>A EC nº 141/2026 redefiniu os limites constitucionais da duração do trabalho no Brasil. Seus principais objetivos são:</p>
          <ul>
            <li><strong>Ampliar o descanso dos trabalhadores:</strong> Garantir obrigatoriamente dois dias de repouso semanal remunerado (DSR).</li>
            <li><strong>Reduzir a jornada máxima:</strong> Mudar o teto semanal de 44 horas para 40 horas.</li>
            <li><strong>Preservar a renda:</strong> Proibir expressamente qualquer redução salarial ou proporcionalização dos pisos das categorias.</li>
          </ul>

          <h2>2. Como fica o fim da Escala 6x1 na prática?</h2>
          <p>No modelo 6x1, o colaborador trabalhava 6 dias consecutivos para descansar apenas 1. Com a nova redação constitucional:</p>
          <ul>
            <li><strong>Direito a 2 dias de folga:</strong> O empregado passa a ter direito a dois dias de repouso semanal remunerado, sendo um deles preferencialmente aos domingos.</li>
            <li><strong>Flexibilidade e Negociação Coletiva:</strong> A emenda admite, excepcionalmente, regimes compensatórios diferenciados, desde que previstos em acordo ou convenção coletiva de trabalho e respeitadas as diretrizes constitucionais.</li>
          </ul>

          <h2>3. Cronograma de Redução Progressiva da Jornada</h2>
          <p>A transição para a nova jornada não ocorre de forma imediata, permitindo um período de adaptação operacional para o mercado:</p>
          <ul>
            <li><strong>1ª Etapa (2 meses após a publicação):</strong> A jornada máxima cai de 44h para 42 horas semanais. Passa a valer obrigatoriamente a previsão de dois dias de repouso semanal remunerado (DSR).</li>
            <li><strong>2ª Etapa (14 meses após a publicação):</strong> A jornada máxima atinge o limite definitivo de 40 horas semanais. É mantido o limite geral de 8 horas diárias, ressalvadas as exceções previstas em lei ou negociação coletiva.</li>
          </ul>

          <h2>4. O salário pode ser reduzido?</h2>
          <p><strong>Não.</strong> A Emenda Constitucional nº 141/2026 é categórica ao proibir a redução salarial.</p>
          <ul>
            <li><strong>Contratos Vigentes:</strong> A diminuição da carga horária semanal não autoriza o abatimento proporcional do salário.</li>
            <li><strong>Pisos Salariais:</strong> A proteção abrange tanto a remuneração total quanto os pisos salariais fixados para cada categoria profissional.</li>
          </ul>

          <h2>5. Regras Específicas e Exceções</h2>
          <p>A emenda estabelece condições diferenciadas para determinadas categorias e modelos operacionais:</p>
          <ul>
            <li><strong>Altos Cargos / Nível Superior:</strong> Regras específicas aplicam-se a profissionais com diploma de nível superior e remuneração mensal igual ou superior a 2,5 vezes o teto dos benefícios do RGPS.</li>
            <li><strong>Contratos Públicos:</strong> Trata de adequações específicas para contratos da administração pública que envolvem alocação de mão de obra.</li>
            <li><strong>MEIs, Micro e Pequenas Empresas:</strong> Previsão de medidas transitórias diferenciadas para MEIs, MEs e EPPs, que serão regulamentadas por Lei Complementar.</li>
          </ul>

          <h2>6. O que muda para as Empresas e RH? (Checklist de Adequação)</h2>
          <p>Para garantir conformidade com a legislação e evitar autuações trabalhistas, o RH e o DP devem focar nos seguintes pontos:</p>
          <ul>
            <li><strong>Revisão de Escalas:</strong> Reorganizar as turmas de trabalho para garantir os 2 dias de DSR.</li>
            <li><strong>Controle de Ponto:</strong> Atualizar parâmetros dos sistemas de ponto eletrônico para as novas cargas horárias e regras de tolerância.</li>
            <li><strong>Dimensionamento de Equipe:</strong> Avaliar se haverá necessidade de contratações adicionais ou redistribuição de turnos.</li>
            <li><strong>Negociação Coletiva:</strong> Acompanhar as orientações e aditivos dos sindicatos patronais e laborais da sua categoria que possam prever regimes compensatórios.</li>
            <li><strong>Folha de Pagamento:</strong> Garantir a manutenção integral do valor dos salários e revisar reflexos em horas extras/adicionais. Adeque o cálculo do valor da hora de trabalho.</li>
          </ul>

          <h2>7. Estratégias Operacionais para Comércio e Varejo</h2>
          <p>O setor varejista — que opera tradicionalmente 7 dias por semana — é um dos mais impactados. Com a eliminação da escala 6x1 tradicional, lojas e supermercados dependem de:</p>
          <ul>
            <li><strong>Ajuste dos Turnos em Dias de Pico:</strong> Concentrar as horas de trabalho nos dias de maior movimento (quinta a domingo) e redistribuir folgas em dias de menor fluxo.</li>
            <li><strong>Contratos Parciais ou Turnos Intercalados:</strong> Avaliar contratações complementares para cobrir as janelas geradas pelos dois dias de folga dos funcionários fixos.</li>
            <li><strong>Cobertura de Finais de Semana:</strong> A escala de folgas rotativas precisa de um dimensionamento mais eficiente para evitar falta de atendimento no sábado e no domingo.</li>
          </ul>

          <h2>8. Soluções para Bares, Restaurantes e Food Service</h2>
          <p>Restaurantes funcionam em horários fracionados e com picos intensos no almoço e no jantar. A transição exige atenção especial na gestão de custo operacional e nas folgas preferencialmente aos domingos:</p>
          <ul>
            <li><strong>Adoção do Formato 5x2 ou Escalas Modulares:</strong> Criar duplas ou trios de trabalho onde a folga de um colaborador seja coberta pela escala normal de outro.</li>
            <li><strong>Reforço com Trabalhadores Intermitentes:</strong> Utilizar o contrato de trabalho intermitente regulamentado para cobrir exclusivamente os picos de sexta a domingo.</li>
            <li><strong>Controle de Descanso Interjornada:</strong> Garantir o intervalo mínimo de 11 horas de descanso entre o encerramento do turno noturno e o início do turno do dia seguinte.</li>
          </ul>

          <hr className={styles.linhaDivisoria} />

          <p className={styles.textoDestaqueAcao}>
            A adequação à EC 141/2026 vai além do cumprimento legal: é um passo estratégico para modernizar a cultura organizacional e evitar severas autuações do MTE e condenações em horas extras e reflexos. Precisa de suporte especializado para revisar contratos, reorganizar escalas e adequar seu departamento pessoal às exigências? Entre em contato com a nossa equipe jurídica e de consultoria para agendar uma avaliação!
          </p>
        </article>

      </div>
    </div>
  );
}

export default FimEscala;